import React from 'react';
import {Translate} from '../../config/TranslationProvider';

const Address = ({location}) =>
    (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h3 className="h4"><span className="la la-user" />&nbsp;<Translate value="address" /></h3>
            </div>
            <div className="widget-body atbd_author_info_widget">
                <div className="atbd_widget_contact_info">
                    <ul>
                        {location.address &&
                            <li>
                                <span className="la la-map-marker" />
                                <span className="atbd_info">{location.address}</span>
                            </li>
                        }
                        {location.city &&
                            <li>
                                <span className="la la-building" />
                                <span className="atbd_info">{location.city + ', ' + location['zip']}</span>
                            </li>
                        }
                        {location.country &&
                            <li>
                                <span className="la la-flag-o" />
                                <span className="atbd_info">{location.country}</span>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    );

export default Address;
